import { Icon } from '@iconify/react/dist/iconify.js';
import { FormControl, FormHelperText, FormLabel, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';

export default function CustomTextField({ isOptional, values, variant, onChange, error, placeholder, type, typePw, height, title, required, rows, multiline, InputProps, disabled, subtitle, width, sx, inputSx, max, backgroundColor, borderRadius, textFieldStyle, paddingTop, paddingBlock, paddingInline, marginTop, showTitle = false, is2dp = false, subtitleTop }) {

    const handleOnChange = (e) => {
        let value = e || "";

        if (type === "number") {
            // Allow only one "." in the input
            const filteredValue = value.replace(/[^0-9.]/g, '');
            const dotCount = (filteredValue.match(/\./g) || []).length;

            if (dotCount > 1) {
                return; // Prevent input if more than one "." exists
            }

            if (max && parseFloat(filteredValue) > max) {
                // setErrorMax(`Value cannot exceed ${max}`); // Set error message
                return;
            }

            onChange(filteredValue);
            setErrorMax(null); // Clear error if within range
        } else if (type === "integer") {
            // Ensure value is numeric and format as a whole number (no decimal places)
            const filteredValue = value.replace(/[^0-9]/g, '');

            if (filteredValue === "") {
                onChange('');
                setErrorMax(null); // Clear error when input is empty
                return;
            }

            const numericValue = parseInt(filteredValue, 10);

            if (max && numericValue > max) {
                // setErrorMax(`Value cannot exceed ${max}`); // Set error message
                return;
            }

            onChange(numericValue);
            setErrorMax(null); // Clear error if within range
        } else if (type === "phone") {
            const filteredValue = value.replace(/[^0-9]/g, '');
            onChange(filteredValue);
        } else {
            onChange(value);
        }

    }

    const [errorMax, setErrorMax] = React.useState(null);

    const handleOnBlur = () => {
        if (type === "number" && is2dp && values) {
            // Ensure the value is rounded to 2 decimal places on blur
            const numericValue = parseFloat(values);
            const roundedValue = numericValue.toFixed(2);
            onChange(roundedValue);
        }
    };
console.log("fsdfds text", values)
    const defaultStyle = {
        backgroundColor: disabled ? '#F1F3F4' : backgroundColor || "",
        color: disabled ? '#52525280' : "",
        marginTop: marginTop || "6px",
        border: '1.5px solid #E6E6E6',
        borderRadius: borderRadius || 3,
        paddingInline: paddingInline || (InputProps && InputProps.startAdornment && type === 'phone' ? 1 : 2),
        // paddingBlock: paddingBlock ? paddingBlock : ((!values && values != 0) || !title) ? "15px" : "6px",
        paddingBlock: paddingBlock ? paddingBlock : "6px",
        // paddingBottom: paddingBlock || "3px",
        width: width && width,
        paddingTop: paddingTop || "auto",
        height: height && height,
        // padding: padding
    };

    return (
        <>
            {subtitleTop && <span style={{ fontSize: 13, color: '#BDBDBD', marginTop: '5px', fontWeight: '400' }}>{subtitleTop}</span>}

            <FormControl variant={variant || "outlined"} fullWidth={width ? false : true} sx={{ ...defaultStyle, ...textFieldStyle }}>
                <div className='d-flex align-items-center'>
                    {InputProps && InputProps.startAdornment && type === 'phone' ? <div style={{ height: '100%' }}>{InputProps.startAdornment}</div> : null}
                    <div
                        style={{
                            borderLeft: InputProps && InputProps.startAdornment && type === 'phone' ? '1.5px solid #E6E6E6' : 'none',
                            paddingLeft: InputProps && InputProps.startAdornment && type === 'phone' ? 12 : 0,
                            paddingRight: InputProps && InputProps.endAdornment ? 8 : 0,
                            width: '100%',
                        }}
                    >
                        <FormLabel
                            style={{
                                fontFamily: 'FunnelSans',
                                fontWeight: 500,
                                // fontSize: showTitle || (values || values == 0) ? 12 : 0,
                                fontSize: showTitle || 12,
                                margin: 0,
                                color: "#808588",
                                justifyContent: "space-between",
                                display: "flex",
                                // opacity: showTitle || (title && (values || values == 0)) ? 1 : 0,
                                opacity: showTitle || 1,
                            }}
                        >
                            {title} {isOptional ? <span className="optional-label">Optional</span> : null}
                        </FormLabel>
                        <TextField
                            size="small"
                            // placeholder={!disabled ? placeholder : ''}

                            placeholder={
                                !disabled &&
                                    String(placeholder || '').trim().toLowerCase() !== String(title || '').trim().toLowerCase()
                                    ? placeholder
                                    : ''
                            }
                            type={typePw}
                            multiline={multiline}
                            rows={rows}
                            InputProps={{
                                disableUnderline: true,
                                startAdornment: InputProps && InputProps.startAdornment && type !== 'phone' ? (<InputAdornment position="start">{InputProps.startAdornment}</InputAdornment>) : null,
                            }}
                            required={required}
                            value={is2dp && !values ? (values === "NaN" || values === "Infinity" ? "" : "") : (values === "NaN" || values === "Infinity" ? "" : values)}
                            disabled={disabled}
                            error={error ? true : false}
                            variant={variant || "standard"}
                            sx={{
                                "& .MuiInput-root": {
                                    fontFamily: 'FunnelSans',
                                    border: 'none'
                                },
                                backgroundColor: disabled ? '#F1F3F4' : backgroundColor || 'white',
                                ...(sx || {}),
                            }}
                            inputProps={{
                                padding: 0,
                                sx: {
                                    '&::placeholder': {
                                        color: '#BDBDBD',
                                        opacity: 1,
                                    },
                                    marginTop: InputProps?.startAdornment ? type === 'phone' ? '0px' : '2px' : '0px',
                                    ...(inputSx || {}),
                                },
                            }}
                            style={{ marginTop: title ? 0 : 2, width: '100%' }}
                            onChange={(e) => handleOnChange && handleOnChange(e.target.value)}
                            onBlur={handleOnBlur}
                        />
                    </div>
                    {InputProps && InputProps.endAdornment ? InputProps.endAdornment : null}

                </div>
            </FormControl>
            {subtitle && <span style={{ fontSize: 13, color: '#BDBDBD', marginTop: '5px', fontWeight: '400' }}>{subtitle}</span>}
            {error && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error || ""}</FormHelperText>}
            {/* {type === "number" && (values === "NaN" || values === "Infinity") && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />Invalid number</FormHelperText>} */}
            {/* {max && errorMax && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{title} cannot exceed {max}</FormHelperText>} */}
        </>
    );
}
